import React, { Component } from 'react'
import ClearIcon from 'material-ui/svg-icons/content/clear'
import SelectAllIcon from 'material-ui/svg-icons/content/content-copy'
import Tappable from 'react-tappable'

class Actions extends Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps !== this.props) {
      return true
    }

    return false
  }

  onClear(e) {
    e.preventDefault()
    e.stopPropagation()
    const { signals, path } = this.props
    signals.client.clearValue({ field: path })
  }

  onSelectAll(e) {
    e.preventDefault()
    e.stopPropagation()
    const { signals, path } = this.props
    signals.client.selectAllOptions({ field: path })
  }

  renderSelectAll() {
    const { isMultiple } = this.props
    if (!isMultiple) {
      return null
    }

    return (
      <Tappable onTap={e => this.onSelectAll(e)}>
        <SelectAllIcon
          hoverColor={'green'}
          color={'rgba(0, 0, 0, 0.498039)'}
          viewBox={'0 0 20 40'}
          style={{
            position: 'absolute',
            cursor: 'pointer',
            zIndex: 10,
            right: 20
          }}
        />
      </Tappable>
    )
  }

  renderClear() {
    const { preventClear, hasValue } = this.props
    if (preventClear || !hasValue) {
      return null
    }
    return (
      <Tappable onTap={e => this.onClear(e)}>
        <ClearIcon
          hoverColor={'red'}
          color={'rgba(0, 0, 0, 0.498039)'}
          viewBox={'0 0 20 40'}
          style={{
            position: 'absolute',
            cursor: 'pointer',
            zIndex: 10,
            right: 0
          }}
        />
      </Tappable>
    )
  }

  render() {
    const { hasFocus, hasOptions, isDate, isFile, disabled } = this.props
    if (hasFocus || disabled) {
      return null
    }
    if (hasOptions || isDate || isFile) {
      return (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
          {hasOptions || isDate ? this.renderSelectAll() : null}
          {this.renderClear()}
        </div>
      )
    }
    return null
  }
}

export default Actions



// WEBPACK FOOTER //
// ./src/components/inputs/actions.js